<template lang="pug">
.channel-ads.inset(v-if="image" :class="[position]")
  .inline-block
    img(:src="image")
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "channel-ads",
  data() {
    return {
      image: null,
      pool: [],
      ads: [],
      type: null,
      position: null,
      interval: null,
      duration: null
    }
  },
  computed: {
    ...mapState("live", ["sidebar"])
  },
  activated() {
    const config = __.device.config("livetv_ads.livetv_ads")
    try {
      let { type, position, interval, duration, images } = JSON.parse(config)

      duration = parseInt(duration)
      interval = parseInt(interval)
      this.ads = images || []
      this.type = type
      this.position = position.split(".").join("-")
      this.interval = interval * 60 * 1000
      this.duration = duration * 1000

      _$.makeTimeout(() => this.init(), this.interval)
    } catch (error) {
      _$.error(error)
    }
  },
  deactivated() {},
  methods: {
    async init() {
      this.generate(this.type === "random")
    },
    async generate(random = false) {
      if (!this.ads.length) return false
      if (!this.pool?.length) this.pool = [...this.ads]

      if (random) {
        const i = Math.floor(Math.random() * this.pool.length)
        await this.show(this.pool[i])
        this.pool.splice(i, 1)
      } else {
        const ad = this.pool.shift()
        await this.show(ad)
      }

      return _$.makeTimeout(() => this.init(), this.interval)
    },
    async show(ad) {
      this.image = ad
      await _$.sleep(this.duration)
      this.image = null
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.inset {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;

  &.bottom {
    align-items: end;
    justify-content: center;
  }
  &.bottom-left {
    align-items: end;
    justify-content: start;
  }
  &.bottom-right {
    align-items: end;
    justify-content: end;
  }

  &.top {
    align-items: start;
    justify-content: center;
  }
  &.top-left {
    align-items: start;
    justify-content: start;
  }
  &.top-right {
    align-items: start;
    justify-content: end;
  }

  &.center {
    align-items: center;
    justify-content: center;
  }
  &.center-left {
    align-items: center;
    justify-content: start;
  }
  &.center-right {
    align-items: center;
    justify-content: end;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
